import $ from 'jquery'
import L from 'leaflet'

import { GeofenceDrawing } from './geofence-drawing'

/**
 * Create a map that allows drawing a polygon.
 * The coordinates of each polygon point make the geofence.
 *
 * Example::
 *
 *    const g = new Geofence('geofence-map')
 *    g.createMap()
 *
 */
class Geofence {
  constructor(id) {
    this.center = [0, 0]
    this.defaultZoom = 16
    this.id = id
    this.map = null
    this.streetLayer = null
    this.satelliteLayer = null
    this.markerLayer = null
    this.drawing = null
    this.tagCoords = [0, 0]
    this.buttons = {}
  }

  /**
   * Add custom buttons to the map.
   */
  addButtons() {
    this.buttons['zoomControl'] = new L.control.zoom({
      zoomInTitle: __('Zoom in'),
      zoomOutTitle: __('Zoom out'),
    }).addTo(this.map)
    this.buttons['showIct'] = L.easyButton(
      '<img src="assets/images/ict-track-icon.png" style="margin-left:-3px";>',
      this.onClickShowIct.bind(this),
      __('Center on ICT')
    ).addTo(this.map)
  }

  /**
   * Add a marker to the markers layer.
   */
  addMarker(coords) {
    const icon = L.icon({
      iconUrl: 'assets/images/ict-tag-marker.png',
      iconSize: [24, 24],
    })
    L.marker(coords, { icon }).addTo(this.markerLayer)
  }

  /**
   * Center the map to coordinates and set the zoom.
   *
   * When zoom is null use the map's current zoom.
   */
  centerMap(center, zoom = null) {
    let newZoom = zoom ? zoom : this.map.getZoom()
    this.center = center
    this.map.setView(center, newZoom)
  }

  /**
   * Fly to the bounded area and center the map
   */
  centerBoundedMap(center, bounds = null) {
    if (bounds) {
      this.map.flyToBounds(bounds, { duration: 1, maxZoom: 16 })
      $(this.id).one('zoomend', () => {
        this.centerMap(center)
      })
    }
    else {
      this.centerMap(center)
    }
  }

  /**
   * Remove the map and drawings
   */
  clearMap() {
    this.map.remove()
    this.map = null
    this.drawing = null
  }

  /**
   * Remove all markers from the markers layer.
   */
  clearMarkers() {
    this.markerLayer.clearLayers()
  }

  /**
   * Create the map, map layers, and controls.
   */
  createMap() {
    this.map = L.map(this.id, {
      zoomControl: false,
    }).setView(this.center, this.defaultZoom)
    this.addButtons()

    // Street view layer
    this.streetLayer = L.tileLayer(
      'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
      {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      }
    )
    // this.streetLayer = L.tileLayer(
    //   'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    //   {
    //     attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
    //     maxZoom: 18,
    //   }
    // )
    this.streetLayer.addTo(this.map)

    // Add a layer for markers
    this.markerLayer = L.layerGroup().addTo(this.map)

    // Initialize Drawing
    this.drawing = new GeofenceDrawing(this.map)
    this.drawing.initializeDrawing()
  }

  /**
   * Disable map use.
   */
  disable() {
    this.map.dragging.disable()
    this.map.touchZoom.disable()
    this.map.doubleClickZoom.disable()
    this.map.scrollWheelZoom.disable()
    this.map.boxZoom.disable()
    this.map.keyboard.disable()
    this.buttons['zoomControl'].disable()
    this.buttons['showIct'].disable()
    this.drawing.buttons['showGeofence'].disable()
    if (this.map.tap) {
      this.map.tap.disable()
    }
    document.getElementById(this.id).style.cursor = 'default'
    document.getElementById(this.id).style.opacity = 0.3
    document.getElementById(this.id).title = __('Enable the "Out of the geofence" notification to edit.')
    // $('.leaflet-control-zoom').css('visibility', 'hidden')
    $('.leaflet-draw-toolbar').css('visibility', 'hidden')
  }

  /**
   * Enable map use.
   */
  enable() {
    this.map.dragging.enable()
    this.map.touchZoom.enable()
    this.map.doubleClickZoom.enable()
    this.map.scrollWheelZoom.enable()
    this.map.boxZoom.enable()
    this.map.keyboard.enable()
    this.buttons['zoomControl'].enable()
    this.buttons['showIct'].enable()
    if ( ! this.drawing.drawable) {
      this.drawing.buttons['showGeofence'].enable()
    }
    if (this.map.tap) {
      this.map.tap.enable()
    }
    document.getElementById(this.id).style.cursor = 'grab'
    document.getElementById(this.id).style.opacity = 1.0
    document.getElementById(this.id).removeAttribute('title')
    // $('.leaflet-control-zoom').css('visibility', 'visible')
    $('.leaflet-draw-toolbar').css('visibility', 'visible')
  }

  /**
   * Get the latitude and logitude of the selected row.
   */
  getTagCoordinates() {
    let coords = null
    if (window.CfgManager.selectedRows.length === 1) {
      let row = window.CfgManager.selectedRows[0]
      if (row.lat_lon) {
        coords = window.latLngFromString(row.lat_lon)
      }
    }

    return coords
  }

  /**
   * Prep the map with a marker of the tag and center on it.
   */
  initializeMap() {
    if (this.map === null) {
      this.createMap()
    }
    this.clearMarkers()
    const editableLayers = this.drawing.editableLayer.getLayers()
    const shouldCenter = editableLayers.length === 0
    const coords = this.getTagCoordinates()
    if (coords !== null) {
      this.tagCoords = [coords.lat, coords.lon]
      this.addMarker(this.tagCoords)
      if (shouldCenter) {
        this.centerMap(this.tagCoords)
      }
    }
    else {
      this.tagCoords = [0, 0]
      if (shouldCenter) {
        this.centerMap(this.tagCoords, 0)
      }
    }
  }

  /**
   * Center the map view on the tag.
   */
  onClickShowIct() {
    this.centerMap(this.tagCoords)
  }

}

export { Geofence }
